import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { SAURABH } from "../utils/siteData";
import { buildWhatsAppLink } from "../utils/whatsapp";

export default function WhatsAppFloatButton() {
  const link = buildWhatsAppLink(
    SAURABH.whatsapp,
    "Namaste 🙏, I would like to enquire about your pooja / astrology services."
  );

  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="group fixed bottom-20 right-4 lg:bottom-6 lg:right-6 z-50 flex items-center"
    >
      {/* tooltip label (desktop hover) */}
      <span className="hidden lg:flex mr-3 items-center bg-white text-maroon-800 text-sm font-semibold px-4 py-2 rounded-full shadow-premium border border-gold-100 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all pointer-events-none whitespace-nowrap">
        Chat with us
      </span>

      <span className="relative">
        {/* pulsing rings */}
        <span className="absolute inset-0 rounded-full bg-green-400 animate-pulse-ring" />
        <span
          className="absolute inset-0 rounded-full bg-green-400 animate-pulse-ring"
          style={{ animationDelay: "0.8s" }}
        />
        {/* button */}
        <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-green-400 to-green-600 hover:from-green-500 hover:to-green-700 text-white shadow-premium-lg text-2xl transition-colors animate-bounce-slow">
          <FaWhatsapp />
        </span>
      </span>
    </a>
  );
}
